export default __webpack_public_path__ + "static/media/ITOPM-booked-dark.d57212e5.svg";